import script from "./SddsFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SddsFooter.vue?vue&type=script&setup=true&lang=js"

import "./SddsFooter.vue?vue&type=style&index=0&id=017fb713&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017fb713"]])

export default __exports__